import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type AddCommentToEnrollmentAccountingInput = {
  enrollmentId: number
  comment: string
}

export function addCommentToEnrollmentAccounting(input: AddCommentToEnrollmentAccountingInput) {
  const { enrollmentId, comment } = input
  return restApiClient
    .url(constructApiUrl(API['enrollment-accountings'].addComment.url, { id: enrollmentId }))
    .post({ comment })
}
